'use client';

import CentredLoadingSpinner from '@atoms/CentredLoadingSpinner';

function Loading() {
  return <CentredLoadingSpinner />;
}

export default Loading;
